import React from 'react'
import list_green from '../../assets/img/icon/list-green.png'
import check_green from '../../assets/img/icon/check-green.png'
import list_white from '../../assets/img/icon/list-white.png'
import check_white from '../../assets/img/icon/check-whit.png'
import star from '../../assets/img/icon/star.png'

const ServiceCardNew = ({ services, isTag, col, openModal }) => {
  console.log('sec: ', services)
  return (
    <div
      className={`grid ${
        col || 'grid-cols-3'
      } gap-5  mb-20 mobile:grid-cols-1 tablet:grid-cols-2 extraScreen:grid-cols-4 maxScreen:grid-cols-4 justify-items-center mobile:mb-5 `}
    >
      {services.map(item => (
        <div
          key={item.id}
          onClick={() => openModal(item.content)}
          className={`flex flex-col w-[326px] maxScreen:w-[310px] border border-[#4EB5C6] rounded-2xl mobile:w-full p-2 ${
            item.id === 4 ? 'text-white' : 'text-[#1B4046]'
          } ${
            item.id === 4
              ? 'bg-gradient-to-t from-[#1B4046] to-[#4EB5C6]'
              : 'bg-gradient-to-t from-[#b4d3d8] from-0% via-[#FFFFFF] via-48%'
          } `}
        >
          <div className={`flex flex-col justify-center items-center`}>
            {item.id === 3 && (
              <button
                className='border border-gray bg-white text-[#1B4046] w-[180px] text-[14px] font-inter-bold rounded-2xl px-4 absolute top-[-12px] ml-[0px] mobile:top-[1010px]'
                style={{
                  boxShadow: '0px 4px 6px -3px rgba(0, 0, 0, 0.4)'
                }}
              >
                <p className='mt-1'>ХЭМНЭЛТТЭЙ</p>
              </button>
            )}
            {item.id === 4 && (
              <button
                className='border border-[#4EB5C6] bg-white w-[180px] text-[14px] text-[#4EB5C6] font-inter-bold mt-[-2px] rounded-2xl px-4 absolute top-[600px] tablet:top-[520px] ml-[0px] 
               extraScreen:top-[-10px] maxScreen:top-[-10px] mobile:top-[1610px] flex flex-row justify-center items-center'
              >
                <img src={star}></img>
                <p className='mt-1 ml-1'>ЗӨВ СОНГОЛТ</p>
              </button>
            )}
            {item.id === 5 && (
              <button
                className='border border-gray bg-white w-[180px] text-[14px]  font-inter-bold  rounded-2xl px-4 absolute top-[600px] ml-[0px] mobile:top-[2195px] tablet:top-[520px] maxScreen:top-[630px]'
                style={{
                  boxShadow: '0px 4px 6px -3px rgba(0, 0, 0, 0.4)'
                }}
              >
                ЭРТЭЧ
              </button>
            )}
          </div>
          <div className='p-2'>
            <div className='flex flex-row items-center justify-start'>
              <p
                className={`font-inter text-[24px] text-start mobile:text-[16px]  `}
              >
                {item.name}
              </p>
              {item.subName && (
                <p
                  className={`font-inter text-[12px] text-center mobile:text-[16px]  ml-1`}
                >
                  {item.subName}
                </p>
              )}
            </div>
            <div className='flex flex-row items-center justify-start mt-[-5px] text-[22px]'>
              <p
                className={`font-inter text-start mobile:text-[16px]  uppercase `}
              >
                Хадгалалт -
              </p>
              {item.price && (
                <p
                  className={`font-inter-bold  text-center mobile:text-[16px]  ml-1`}
                >
                  {item.price === 'soon'
                    ? 'Тун удахгүй'
                    : new Intl.NumberFormat('mn-MN').format(item.price)}
                  {item.price === 'soon' ? '' : '₮'}
                </p>
              )}
            </div>
            <div className='flex flex-row justify-start items-center mt-8 h-10'>
              <p
                className={`${
                  item.price === 'soon' ? 'text-[30px]' : 'text-[40px]'
                } font-inter-bold`}
              >
                {item.price === 'soon'
                  ? 'Тун удахгүй'
                  : item.monthlyPayment + ''}
              </p>
              <div className='flex flex-col text-[12px] font-normal ml-1'>
                <p>ХУВААЖ ТӨЛБӨЛ</p>
                <p className='font-inter-bold'>/САРД</p>
              </div>
            </div>
            <button
              className={`border border-black/30 mobile:h-12 mobile:text-[14px] h-[48px] bg-white text-[#1B4046]
              w-full rounded-lg p-4 flex items-center justify-center gap-2 cursor-pointer mt-5 `}
            >
              <p className=' text-[16px]'>Дэлгэрэнгүй</p>
            </button>
            <hr className='h-[1px] bg-[#1B4046] mt-5 mb-3'></hr>
            {item.gText && (
              <p className='text-[14px] h-7 mb-4  font-inter-bold'>
                {item.gText}
              </p>
            )}
            <div className='h-[200px]'>
              {item.list &&
                item.list.map((detail, index) => {
                  // Check if the item is in the last two positions
                  const isLastTwo = index >= item.list.length - 2
                  return (
                    <div
                      key={index}
                      className='flex flex-row  text-[12px] gap-4 p-1 justify-start items-center'
                    >
                      {item.id === 4 && (
                        <img
                          src={isLastTwo ? list_white : check_white}
                          className={` ${
                            isLastTwo
                              ? 'h-[24px] w-[24px]'
                              : 'h-[18px] w-[22px]'
                          }`}
                        ></img>
                      )}
                      {item.id !== 4 && (
                        <img
                          src={isLastTwo ? list_green : check_green}
                          className={` ${
                            isLastTwo
                              ? 'h-[24px] w-[24px]'
                              : 'h-[18px] w-[22px]'
                          }`}
                        ></img>
                      )}
                      <p className='text-[16px]'>{detail}</p>
                    </div>
                  )
                })}
            </div>
            {item.hemnelt && (
              <>
                <hr className='h-[1px] bg-[#1B4046] mt-5 mb-3'></hr>
                <p className='text-[14px] text-center mt-[-5px]'>ХЭМНЭЛТ</p>
                <p className='text-[21px] text-center font-inter-bold mt-[-5px]'>
                  {new Intl.NumberFormat('mn-MN').format(item.hemnelt)}₮
                </p>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default ServiceCardNew
